// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__4vDlH","total":"styles_total__KriKQ","titleWrapper":"styles_titleWrapper__3vU__","title":"styles_title__1wYID"};